import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const NotifyIcon = ({ sx, className, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 18 19"
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      {...otherProps}
    >
      <path
        d="M13.7654 6.09992C13.7654 3.28331 11.4807 1 8.66239 1C5.84408 1 3.55938 3.28331 3.55938 6.09992C3.55938 12.0498 1.00787 13.7498 1.00787 13.7498H16.3169C16.3169 13.7498 13.7654 12.0498 13.7654 6.09992"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1338 17.1497C9.82947 17.674 9.26888 17.9967 8.66241 17.9967C8.05594 17.9967 7.49535 17.674 7.19104 17.1497"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default memo(NotifyIcon);
